import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import UserService from "../../Modules/Services/user.service.ts";

const ProtectedRoute = () => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      const ok = await UserService.checkAuth();
      if (!mounted) return;
      setIsAuthed(ok);
      setIsChecking(false);
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  if (isChecking) return null;
  return isAuthed ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
